
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    logout: any;
    isDisplay: boolean;
};

export const UserNoAddressDialog: React.FC<Props> = ({
    logout,
    isDisplay
}) => {
    const { t } = useTranslation('common');

    const [isVisible, setIsVisible] = useState<boolean>(isDisplay);

    const onHideDialog = () => {
        setIsVisible(false);
    }
    return (
        <Dialog
            visible={isVisible}
            modal
            onHide={onHideDialog}
            closeOnEscape={false}
            closable={false}
            blockScroll={true}
            draggable={false}
        >
            <div className="mb-6 mx-2 flex flex-wrap flex-row justify-content-center align-items-center" style={{ gap: '30px' }}>

                <i className="pi pi-ban" style={{ 'fontSize': '4em', color: '#FBC02D' }}></i>
                <div>
                    <h5>{t('Customer_Cart_NoAddressAccess')}</h5>
                    <h5>{t('NewCart_ContactAdmin')} </h5>
                </div>
            </div>
            <div className='flex flex-wrap justify-content-center'>

                <Button label={t('NewCart_Logout')} onClick={logout} className='p-button-warning w-full' />
            </div>
        </Dialog >
    )
}